function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import Popup from '../Popup';
import Icon from '../Icon';
import DatePanel from './DatePanel';
import DateHeader from './DateHeader';
import { getValueFromDateObj, getDateObjFromValue, getDateList, FixDateListSelected } from './helper';
import './style.less';
/* const format = (timestamp) => {
 *     const date = new Date(timestamp);
 *     const year = date.getFullYear();
 *     const month = date.getMonth() + 1;
 *     const day = date.getDate();
 *     return [year, month, day].join('-');
 * }; */

var DatePicker = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(DatePicker, _KZUIComponent);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _this.autoBind('handleDateSelect', 'handleClickInput', 'handleHeaderChange', 'handleHover', 'handleBlur'); // 获取月份时，需要减1，因为系统内是用0-11表示12个月份


    var value = props.value || '2018-2-22';
    var dateObj = getDateObjFromValue(value);
    _this.state = {
      expand: false,
      dateList: getDateList(dateObj, dateObj),
      value: value,
      dateObj: dateObj,
      selectedValue: value
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value === this.state.selectedValue) return;
      var newDateObj = getDateObjFromValue(nextProps.value);
      this.setState({
        value: nextProps.value,
        selectedValue: nextProps.value,
        dateObj: newDateObj,
        dateList: getDateList(newDateObj, newDateObj)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBlur, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBlur, false);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (!this.state.expand) return;

      if (this.wrp.contains(e.target) || this.popup.contains(e.target)) {
        return;
      }

      this.setState({
        expand: false
      });
    }
  }, {
    key: "getPopup",
    value: function getPopup() {
      var _this$state = this.state,
          value = _this$state.value,
          dateObj = _this$state.dateObj,
          dateList = _this$state.dateList;

      var _this$wrp$getBounding = this.wrp.getBoundingClientRect(),
          x = _this$wrp$getBounding.x,
          y = _this$wrp$getBounding.y,
          height = _this$wrp$getBounding.height;

      var popupStyle = {
        left: x,
        top: y + height + 1
      };
      return /*#__PURE__*/React.createElement(Popup, {
        hide: false,
        style: popupStyle
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.storeRef('popup')
      }, /*#__PURE__*/React.createElement(DateHeader, {
        dateObj: dateObj,
        onChange: this.handleHeaderChange
      }), /*#__PURE__*/React.createElement(DatePanel, {
        value: value,
        onChange: this.handleDateSelect,
        dateList: dateList
      })));
    }
  }, {
    key: "handleHeaderChange",
    value: function handleHeaderChange(data) {
      var newDateObj = _objectSpread({}, this.state.dateObj, {}, data);

      var newValue = getValueFromDateObj(newDateObj);
      var selectedDateObj = getDateObjFromValue(this.state.selectedValue);
      var newDateList = getDateList(newDateObj, selectedDateObj);
      this.setState({
        dateObj: newDateObj,
        value: newValue,
        dateList: newDateList
      });
    }
  }, {
    key: "handleHover",
    value: function handleHover(data) {
      var newDateObj = _objectSpread({}, this.state.dateObj, {}, data);

      var newValue = getValueFromDateObj(newDateObj);
      this.setState({
        dateObj: newDateObj,
        value: newValue
      });
    }
  }, {
    key: "handleClickInput",
    value: function handleClickInput() {
      var expand = this.state.expand;
      this.setState({
        expand: !expand
      });
    }
  }, {
    key: "handleDateSelect",
    value: function handleDateSelect(data) {
      var onChange = this.props.onChange;

      var newDateObj = _objectSpread({}, this.state.dateObj, {}, data);

      var newValue = getValueFromDateObj(newDateObj);
      var newDateList = FixDateListSelected(this.state.dateList, newDateObj);
      onChange({
        value: newValue,
        name: name
      });
      this.setState({
        dataObj: newDateObj,
        value: newValue,
        selectedValue: newValue,
        expand: false,
        dateList: newDateList
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-datepicker';

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          error = _this$props.error,
          disabled = _this$props.disabled,
          others = _objectWithoutProperties(_this$props, ["className", "style", "error", "disabled"]);

      var _this$state2 = this.state,
          expand = _this$state2.expand,
          selectedValue = _this$state2.selectedValue;
      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "__error"), error), _defineProperty(_classNames, "".concat(clsPrefix, "__disabled"), disabled), _classNames), className);
      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        className: cls,
        style: style
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--display"),
        onClick: this.handleClickInput,
        ref: this.storeRef('wrp')
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "--input"),
        type: "text",
        name: "",
        value: selectedValue,
        readOnly: true
      }), /*#__PURE__*/React.createElement(Icon, {
        iconClass: "".concat(clsPrefix, "--icon kz-e-calendar")
      })), expand && this.getPopup(clsPrefix));
    }
  }]);

  return DatePicker;
}(KZUIComponent);

DatePicker.defaultProps = {
  value: '',
  name: '',
  onChange: function onChange() {}
};
DatePicker.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};
export default DatePicker;